import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";

import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { getParameterFromManager } from "../../../services/Utils";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
  uploadVideoToS3,
} from "../../Requirement/services/RequirementServices";
import ProformaInvoices from "./ProformaInvoices";

const ProcurementInvoices = () => {
  const [activeTab, setActiveTab] = useState("Proforma Invoices");
  const [allProjectList, setAllProjectList] = useState([]);
  const [activeUser, setActiveUser] = useState("");
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const loadProjectList = useCallback(async () => {
    setLoading(true);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProjects",
          userOrder: "ProjectID",
          rowStart: 0,
          pageSize: 1,
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProjects",
            userOrder: "ProjectID",
            rowStart: 0,
            pageSize: totalCount,
          }),
        ]);
        setAllProjectList(allProducts);
      } else {
        setAllProjectList([]);
      }
    } catch (error) {
      console.error("Error loading projects: ", error);
      setAllProjectList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  console.log("activeTab::", activeTab);
  const tabs = ["Proforma Invoices", "Tax Invoices"];
  const renderTabContent = () => {
    switch (activeTab) {
      case "Proforma Invoices":
        return <ProformaInvoices />;
      default:
        return <ProformaInvoices />;
    }
  };

  useEffect(() => {
    console.log("Procurement Invoices");
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        } else {
          setActiveUser(user.attributes.email);
        }
        await getParameterFromManager("INR_TO_USD");
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();

    loadProjectList();
  }, [navigate, loadProjectList]);

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ProcurementInvoices;
